module.exports = __webpack_public_path__ + "assets/Arbelos.5703cf3861fbc80458e02e1f2ea0cf2a.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Arbelos.gmt
// module id = 903
// module chunks = 0